// This is just an example,
// so you can safely delete all default props below

export default {
  app: {
    name: 'Velociti',
  },
  field: {
    required: 'This field is required',
  },
}
